import { Navigate } from "react-router-dom";
import AuthController from "controllers/authController";

const PublicRoutes = ({ children }) => {
  const isLoggedIn = AuthController.isUserLoggedIn();

  if (isLoggedIn) {
    return <Navigate to="/personalAccount" replace />;
  }

  return children;
};

export default PublicRoutes;
